import {contacts} from './tableModules/contacts'
import {containerTemplates} from './tableModules/containerTemplates'
import {containers} from './tableModules/containers'
import {contractors} from './tableModules/contractors'
import {loginProviders} from './tableModules/loginProviders'
import {organisations} from "./tableModules/organisations"
import {plans} from './tableModules/plans'
import {projects} from './tableModules/projects'
import {users} from './tableModules/users'
import {wasteCategories} from './tableModules/wasteCategories'
import {wastes} from './tableModules/wastes'
import {customers} from "~/utils/tableModules/customers"
import {mailTemplates} from "~/utils/tableModules/mailTemplates"
import {mails} from "~/utils/tableModules/mails"
import {orders} from "~/utils/tableModules/orders"

export const tableModules: TableModules = {
    contractorContacts: {
        ...contacts,
        name: 'contractorContacts',
        route: 'spa.system.contractors.contacts',
        routeParams: [{
            param: "contractor",
            prop: "contractor_id"
        }],
    } as TableModule,
    contractors,
    loginProviders,
    customers,
    organisations,
    projects,
    organisationUsers: {
        ...users,
        name: 'organisationUsers',
        route: 'spa.system.organisations.users',
        routeParams: [{
            param: "organisation",
            prop: "organisation_id"
        }]
    } as TableModule,
    organisationProjects: {
        ...projects,
        name: 'organisationProjects',
        route: 'spa.system.organisations.projects',
        routeParams: [{
            param: "organisation",
            prop: "organisation_id"
        }],
    } as TableModule,
    plans,
    projectWastes: {
        ...wastes,
        name: 'projectWastes',
        route: 'spa.system.organisations.projects.wastes',
        routeParams: [
            {
                param: "organisation",
                prop: "organisation_id",
            },
            {
                param: "project",
                prop: "project_id",
            },
        ],
    } as TableModule,
    users,
    wastes,
    wasteCategories,
    mailTemplates,
    mails,
    containers,
    orders,
    projectContainers: {
        ...containers,
        name: 'projectContainers',
        route: 'spa.system.organisations.projects.containers',
        routeParams: [
            {
                param: "organisation",
                prop: "organisation_id",
            },
            {
                param: "project",
                prop: "project_id",
            },
        ],
    } as TableModule,
    containerTemplates,
    projectOrders: {
        ...orders,
        name: 'projectOrders',
        route: 'spa.system.organisations.projects.orders',
        routeParams: [
            {
                param: "organisation",
                prop: "organisation_id",
            },
            {
                param: "project",
                prop: "project_id",
            },
        ],
    } as TableModule,
}
